import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../../../components/Button";
import {
  ButtonContainer,
  CancelButton,
  confirmModalCss,
  ContentContainer,
  ModalSubtitle,
} from "../../CustomOptionsBar.styles";

type ConfirmISHLTBaselineStatusChangeProps = {
  ishltEnabledStatus: boolean;
  onClose(confirm: boolean): void;
};

export function ConfirmISHLTBaselineStatusChange({
  ishltEnabledStatus,
  onClose,
}: ConfirmISHLTBaselineStatusChangeProps) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirmUpdate = () => {
    setIsLoading(true);
    onClose(true);
  };

  const handleCancel = () => {
    onClose(false);
  };

  return (
    <Modal
      title={t(
        ishltEnabledStatus
          ? "patientPage_measurementModal_baselineModal_turnOffIshltTitle"
          : "patientPage_measurementModal_baselineModal_turnOnIshltTitle"
      )}
      open
      zIndex={3001}
      footer={null}
      width={600}
      height="400px !important"
      onCancel={handleCancel}
      className={confirmModalCss()}
      centered
      destroyOnHidden
    >
      <ContentContainer>
        <ModalSubtitle>
          {t(
            ishltEnabledStatus
              ? "patientPage_measurementModal_baselineModal_disableIshltBody"
              : "patientPage_measurementModal_baselineModal_enableIshltBody"
          )}
        </ModalSubtitle>

        <ButtonContainer>
          <Button
            label={t("patientPage_measurementModal_baselineModal_confirm")}
            type="button"
            onClick={handleConfirmUpdate}
            isLoading={isLoading}
          />
          <CancelButton isModal onClick={handleCancel}>
            {t("common_cancel")}
          </CancelButton>
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
}
